import { getContainerTypes } from "../../productCommons/index.js";

type OrderItem = {
  quantity: number;
  containerType: string | null;
};

export const getOrderItemCountOfContainerType = ({
  containerType,
  orderItemList,
}: {
  containerType: string;
  orderItemList: OrderItem[];
}) => {
  return orderItemList
    .filter((orderItem) =>
      containerType === "any"
        ? !!orderItem.containerType
        : getContainerTypes(orderItem.containerType).includes(containerType),
    )
    .reduce((sum, orderItem) => sum + orderItem.quantity, 0);
};
